import React from "react";
import { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

const FaqItem = ({ question, answer, isOpen, onToggle }) => (
  <div className="w-full border border-[#3a3a3a]/20 rounded-lg bg-white shadow-sm">
    <button
      type="button"
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-3 px-4 h-12"
    >
      <span className="text-left text-base font-medium text-primary">
        {question}
      </span>
      <ChevronDownIcon
        className={`h-5 w-5 text-gray-500 transition-transform ${
          isOpen ? "rotate-180" : ""
        }`}
      />
    </button>

    <div
      className={` px-4 overflow-hidden transition-all duration-200 ${
        isOpen ? "max-h-96 pb-4 border-t pt-4" : "max-h-0 pb-0"
      }`}
    >
      <p className="text-sm text-gray-700">{answer}</p>
    </div>
  </div>
);
const FAQFr = () => {
  const [openKey, setOpenKey] = useState(null);
  const sections = [
    {
      title: "Produits et services",
      questions: [
        [
          "Est-ce que tous les produits/services vendus sont vérifiés par Ananas Solutions ?",
          "Oui. Seules les compagnies autorisées et validées peuvent offrir leurs produits et services sur la plateforme.",
        ],
      ],
    },
    {
      title: "Compte utilisateur",
      questions: [
        [
          "Comment créer un compte ?",
          "Cliquez sur « Se connecter », puis sur « Créer un compte ». Remplissez le formulaire ou utilisez la connexion Google et validez le code reçu par courriel.",
        ],
        [
          "Comment réinitialiser mon mot de passe ?",
          "Cette fonctionnalité n’est pas encore disponible, mais elle sera ajoutée prochainement (à venir).",
        ],
        [
          "Puis-je changer mon adresse courriel associée ?",
          "Pour modifier votre adresse courriel, veuillez écrire à information@ananassolutions.com.",
        ],
        [
          "Comment supprimer mon compte ?",
          "Vous pouvez demander la suppression en écrivant à privacy@ananassolutions.com.",
        ],
      ],
    },
    {
      title: "Représentants et partenaires",
      questions: [
        [
          "Comment devenir représentant ?",
          "Veuillez contacter un représentant de votre région via le site ananassolutions.ca/trouver-un-representant et soumettre votre demande.",
        ],
      ],
    },
    {
      title: "Paiements et abonnements",
      questions: [
        [
          "Quels abonnements proposez-vous ?",
          "Nous offrons des abonnements qui incluent différents services pour les entreprises, tels que prises de photos, vidéos, montages et campagnes publicitaires.",
        ],
        [
          "Puis-je payer en plusieurs versements ?",
          "Non. Chaque abonnement est valide pour une période déterminée (3 mois, 6 mois ou 1 an) et inclut les services correspondants.",
        ],
      ],
    },
    {
      title: "Livraison et retours",
      questions: [
        [
          "Quels transporteurs utilisez-vous ?",
          "Les livraisons sont gérées par les fournisseurs. Chaque entreprise choisit son transporteur pour l’expédition.",
        ],
        [
          "Comment sont calculés les frais de livraison ?",
          "Les frais de livraison sont calculés par chaque entreprise expéditrice. Ananas Solutions ne gère aucune livraison directe.",
        ],
        [
          "Offrez-vous la livraison internationale ?",
          "Cela dépend du transporteur choisi par le fournisseur.",
        ],
        [
          "Comment puis-je retourner un produit ou signaler un problème ?",
          "Pour un retour, contactez directement le fournisseur. En cas de problème avec un produit ou service, contactez-nous d’abord à information@ananassolutions.com.",
        ],
      ],
    },
    {
      title: "Données personnelles et Loi 25",
      questions: [
        [
          "Qui est le responsable de la protection des renseignements personnels ?",
          "Le responsable est le Directeur des technologies. Vous pouvez le contacter à privacy@ananassolutions.com.",
        ],
        [
          "Où sont hébergées mes données ?",
          "Nous faisons de notre mieux pour que vos données soient conservées au Canada et au Québec lorsque c’est possible.",
        ],
        [
          "Puis-je retirer mon consentement marketing ?",
          "Oui. Vous pouvez vous désabonner des courriels en cliquant sur le lien prévu dans chaque message. Concernant les publicités affichées sur le site, il n’est pas possible de les retirer, mais nous limitons au maximum leur intrusion.",
        ],
      ],
    },
    {
      title: "Aspects légaux",
      questions: [
        [
          "Quelle est l’entité légale derrière Ananas Solutions ?",
          "Ananas Solutions est un produit de Ananas Acti-Solutions inc.",
        ],
        [
          "En cas de litige, quelle juridiction s’applique ?",
          "Les litiges seront traités au cas par cas, mais toujours dans la province de Québec.",
        ],
        [
          "Est-ce que les conditions d’utilisation peuvent changer ?",
          "Oui, elles peuvent être modifiées en tout temps. Un avis sera publié sur le site lors d’une mise à jour importante.",
        ],
        [
          "Est-ce qu’Ananas Solutions offre des garanties sur les services tiers ?",
          "Nous ne pouvons pas garantir la qualité des entreprises tierces. Toutefois, nous faisons tout notre possible pour satisfaire nos clients. Les entreprises qui ne respectent pas nos conditions d’utilisation ou qui reçoivent trop de plaintes peuvent être exclues de la plateforme après étude par notre équipe.",
        ],
      ],
    },
    {
      title: "Support et assistance",
      questions: [
        [
          "Comment contacter le support ?",
          "Vous pouvez nous joindre par courriel à information@ananassolutions.com ou par téléphone au 450-700-1721. Si aucun agent n’est disponible, laissez un message ou contactez-nous par courriel.",
        ],
        [
          "Est-ce que vous offrez un support bilingue ?",
          "Oui, nous offrons un service en français et en anglais.",
        ],
        [
          "Puis-je soumettre une demande via le site ?",
          "Oui, vous pouvez utiliser le formulaire disponible sur ananassolutions.ca/contact.",
        ],
        [
          "Proposez-vous des tutoriels ?",
          "Pas pour le moment, mais ils seront ajoutés prochainement.",
        ],
      ],
    },
  ];

  const toggle = (key) => {
    setOpenKey((prev) => (prev === key ? null : key));
  };

  return (
    <div className="container mx-auto px-4 py-8 text-onWhite">
      <h1 className="text-3xl font-bold text-center mb-8">
        FAQ – Foire aux questions
      </h1>

      {sections.map((section, sIdx) => (
        <div key={sIdx} className="mb-8">
          <h2 className="text-xl font-semibold mb-4">{section.title}</h2>

          <div className="flex flex-col gap-3 w-full">
            {section.questions.map(([q, a], idx) => {
              const key = `${sIdx}-${idx}`;
              return (
                <FaqItem
                  key={key}
                  question={q}
                  answer={a}
                  isOpen={openKey === key}
                  onToggle={() => toggle(key)}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQFr;
